<template>
    <div class="home" ref="home">
        <Header :scrollTop="scrollTop" :goodsInfo="goodsInfo" title="八点秒得" v-if="isInSmartCityApp" />

        <!-- <van-nav-bar fixed placeholder title="八点秒得" left-arrow @click-left="$router.back()" /> -->

        <Banner />
        <Broadcast />

        <div class="main-wrap">
            <div class="main-title">今日推荐</div>

            <div class="main-banner">
                <van-swipe :autoplay="5000" indicator-color="#ff991d">
                    <van-swipe-item v-for="(image, index) in bannerList" :key="index">
                        <img v-lazy="image" />
                    </van-swipe-item>
                </van-swipe>
            </div>

            <div class="main-info">
                <div class="info-name">
                    {{ goodsInfo.goodsName }}
                </div>
                <div class="info-price">
                    <span>￥{{ goodsInfo.price }} </span>
                    <span> </span>
                </div>
            </div>

            <!-- <div class="main-select" v-if="goodsInfo.skuList"> -->
            <!-- <div class="select-item">
                    <span class="label">
                        <span>{{ getType(options[checked - 1].text) }}</span>
                    </span>
                    <span class="label">
                        <span>￥</span>
                        <span>{{ getPrice(options[checked - 1].text) }}</span>
                    </span>
                    <van-icon name="add-o" size=".5rem" color="#666" @click="$refs.PopSku.show = true" />
                </div> -->
            <!-- </div> -->
            <PopSku ref="PopSku" :goodsInfo="goodsInfo" @select="onSelectSku" />

            <!-- <div class="main-btn" v-if="!isInSmartCityApp"></div> -->

            <div class="main-btn">
                <template v-if="!isFinish">
                    <div class="btn" v-if="!isTimeOver">
                        <span>距离抢购开始</span>
                        <van-count-down
                            :time="countDownTime"
                            format="HH 时 mm 分 ss 秒"
                            @finish="onCountDownFinish"
                            :auto-start="isStart"
                        />
                    </div>

                    <div class="btn" v-if="isTimeOver && !isGet && !isPayed" @click="onRushBuy">
                        <span v-if="!isInSmartCityApp">微信支付 </span>
                        <span v-else>抢购 </span>
                    </div>
                    <div class="btn" v-if="isTimeOver && isGet && !isPayed" @click="onOrderPay">您有订单暂未支付</div>
                    <div class="btn" v-if="isTimeOver && isPayed">已秒得</div>
                </template>

                <div class="btn grey" v-if="isFinish">今日活动已结束</div>
                <div class="btn orange" style="margin-top: 30px" @click="goApp" v-if="!isInSmartCityApp">
                    南太湖号支付
                </div>
            </div>

            <div class="main-goods">
                <div class="goods-text" v-html="goodsInfo.content"></div>
            </div>
        </div>

        <Footer :goodsInfo="goodsInfo" />
        <!-- <div class="btn" @click="onRushBuy" >抢购</div> -->

        <OrderForm
            ref="SubmitOrderForm"
            :orderId="orderId"
            :timeout="timeout"
            :goodsInfo="goodsInfo"
            :checked="checked"
        />
       
    </div>
</template>

<script>
import axios from 'axios'
import { debounce } from 'lodash'
import { getOpenId, doSecKill, getSecOrderInfo, getRecordList, getStartTime, getGoodsInfo } from '@/api/home'
import { finishTask } from '@/api/task'
import Header from '@/components/Header'
import Banner from './components/Banner'
import Broadcast from './components/Broadcast'
import Footer from './components/Footer.vue'
import OrderForm from '@/components/order-form.vue'
import PopSku from '@/components/pop-sku.vue'
import VConsole from 'vconsole'
const isWechat = () => {
    return String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) === 'micromessenger'
}

export default {
    name: 'Home',
    components: {
        Header,
        Banner,
        Broadcast,
        Footer,
        OrderForm,
        PopSku,
    },

    data() {
        return {
            scrollTop: 0,
            bannerList: [],
            goodsInfo: {},
            showSku: false,

            timer: null,
            isTimeOver: false,
            isGet: false,
            isPayed: false,
            isFinish: false,

            countDownTime: 0,
            isStart: false,

            orderId: 0,
            timeout: 0,

            checked: 1,
            //微信code
            wxCode: '',
        }
    },
    computed: {
        options() {
            let arr = []

            if (this.goodsInfo.remark) {
                this.goodsInfo.remark.split(',').map((v, i) => {
                    arr.push({ text: v, value: i + 1 })
                })
            }
            return arr
        },
    },
    methods: {
        onCountDownFinish() {
            this.isTimeOver = true
        },
        goApp() {
            window.location.href = 'https://nthh.media.hugd.com/html/guidePage/index.html?code=EightSale'
        },

        onRushBuy() {
            if (this.goodsInfo.linkUrl) {
                SmartCity.linkTo({
                    innerLink: this.goodsInfo.linkUrl,
                })

                return
            }
            // window.location.href ='http://h5.96345.hz66.com/#/&_ddtarget=push'

            this.$refs.PopSku.show = true

            // this.doSecKill()
        },

        onOrderPay() {
            this.$router.replace('/order')
        },
        onSelectSku(skuId) {
            console.log(skuId)
            this.checked = skuId

            this.doSecKill(skuId)

            // console.log(value)
        },
        getType(str) {
            return str.split('#')[0] || ''
        },
        getPrice(str) {
            return str.split('#')[1] || ''
        },
        async finishTask() {
            // console.log(this.$store.state.nthUserInfo)
            const { data: res } = await finishTask({
                m2oId: this.$store.state.nthUserInfo.userid,
            })

            console.log('finishTask', res)

            if (res.code == 200) {
                if (res.data) {
                    SmartCity.creditRulesUpdate({
                        availableScore: res.data.availableScore,
                    })
                    this.$toast(res.data.message)
                }

                // this.getFavoriteServeList()
            }
        },

        init() {
            const isApp = SmartCity.isSmartCityApp()
            if (isApp) {
                this.getNthUserInfo()
            } else {
                // this.$router.replace('/share')
            }
        },

        getNthUserInfo() {
            SmartCity.getUserInfo((res) => {
                if (res && res.userInfo) {
                    this.$store.commit('setNthUserInfo', res.userInfo)
                    this.$store.commit('setUserTokenKey', res.userInfo.userTokenKey)

                    this.initOrderData()
                    this.finishTask()
                } else {
                    this.$dialog
                        .alert({
                            title: '提醒',
                            message: '请先登录南太湖号',
                        })
                        .then(() => {
                            this.$router.replace('/error-unlogin')
                        })
                }
            })
        },

        async doSecKill(skuId) {
            this.$toast.loading({
                duration: 0,
                message: '抢购中...',
            })

            let secKillUrl =
                process.env.NODE_ENV === 'development'
                    ? 'https://flash-sale-api.zhijianmedia.cn/rob'
                    : process.env.NODE_ENV === 'test'
                    ? 'https://flash-sale-backend-test.zhijianmedia.cn/rob/'
                    : 'https://flash-sale-api.zhijianmedia.cn/rob'

            const { data: res } = await axios.post(secKillUrl + '/secKill/doSecKill', {
                m2oId: this.$store.state.nthUserInfo.userid,
                token: this.$store.state.token,
                skuId,
            })

            console.log('抢购中', res)
            if (res.code == 200) {
                this.$toast.clear()
                this.$refs.SubmitOrderForm.popupShow = true
                this.createTimer()
            } else {
                return this.$toast.fail(res.msg)
            }
        },

        async getSecOrderInfo() {
            const { data: res } = await getSecOrderInfo({
                m2oId: this.$store.state.nthUserInfo.userid,
            })

            console.log('订单', res)
            if (res.code == 200) {
                this.orderId = res.data.id
                this.createTime = res.data.createTime
                this.timeout = res.data.timeout
            } else {
                this.$toast.loading({
                    duration: 2000,
                    message: '订单创建中  ...',
                    loadingType: 'spinner',
                })
            }
        },

        async getStartTime() {
            const { data: res } = await getStartTime()
            if (res.code == 200) {
                let date = res.data.replace(/-/g, '/')
                this.countDownTime = Date.parse(new Date(date)) - new Date().getTime()
                this.isStart = true
            }
        },

        async getGoodsInfo() {
            const { data: res } = await getGoodsInfo()
            if (res.code == 200) {
                this.goodsInfo = res.data
                this.bannerList = res.data.bannerList.split('|')
                this.$store.commit('setPayLimit', res.data.limit)
                // this.goodsInfo.remark = '规格1#0.01,规格2#0.02,规格3#0.03'
                this.$store.commit('setGoodsInfo', this.goodsInfo)
            }

            console.log('商品信息', res)
        },

        async initOrderData() {
            const { data: res } = await getSecOrderInfo({
                m2oId: this.$store.state.nthUserInfo.userid,
            })

            console.log('首次查询订单', res)
            if (res.code == 200) {
                this.orderId = res.data.id
                this.timeout = res.data.timeout

                this.isGet = true
            } else {
                if (res.code == 200005) {
                    this.isPayed = true
                }

                if (res.code == 200102) {
                    this.isFinish = true
                }
            }
        },
        createTimer() {
            this.stopTimer()

            this.timer = setInterval(async () => {
                const { data: res } = await getSecOrderInfo({
                    m2oId: this.$store.state.nthUserInfo.userid,
                })

                console.log('订单', res)

                if (res.code == 200) {
                    this.$toast.clear()

                    this.orderId = res.data.id
                    this.timeout = res.data.timeout
                    this.stopTimer()
                }

                if (res.code == 200004) {
                    this.$toast.loading({
                        duration: 2000,
                        message: '订单创建中',
                        loadingType: 'spinner',
                    })
                }
            }, 1000)
        },
        stopTimer() {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
        },
        getWechatCode() {
            let appid = 'wxc0ae0375c6f4a068' //微信APPid
            let code = this.getUrlCode().code //是否存在code
            let local = window.location.href
            if (code == null || code === '') {
                //不存在就打开上面的地址进行授权
                window.location.href =
                    'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
                    appid +
                    '&redirect_uri=' +
                    encodeURIComponent(local) +
                    '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
            } else {
                console.log('当前2', window.location.href)

                this.wxCode = code
                this.getOpenId()

                console.log('获取到的微信code', code)
            }
        },
        getUrlCode() {
            // 截取url中的code方法
            var url = location.search
            var theRequest = new Object()
            if (url.indexOf('?') != -1) {
                var str = url.substr(1)
                var strs = str.split('&')
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1]
                }
            }
            return theRequest
        },
        async getOpenId() {
            const { data: res } = await getOpenId({
                wxCode: this.wxCode,
                url: encodeURIComponent(window.location.href),
            })

            console.log(res)
            if (res.code == 200) {
                sessionStorage.setItem('openId', res.data.openId)
                sessionStorage.setItem('timestamp', res.data.timestamp)
                sessionStorage.setItem('noncestr', res.data.noncestr)
                sessionStorage.setItem('signature', res.data.sign)

                this.$store.commit('setNthUserInfo', {
                    userid: res.data.openId,
                })
                this.$store.commit('setUserTokenKey', res.data.openId)

                // this.timestamp = res.data.timestamp
                // this.nonceStr = res.data.noncestr
                // this.signature = res.data.sign
                this.initOrderData()
                this.registerSdk()
            }
        },

        async registerSdk() {
            // 注册sdk

            // const { data: res } = await axios.get(
            //     'https://nthhserve.hugd.com/pledgeManage/getWecatTicketAndSaveNew?url=' + window.location.href
            // )
            // if (res.code == 200) {
            wx.config({
                debug: false,
                appId: 'wxc0ae0375c6f4a068', // 必填，公众号的唯一标识
                timestamp: sessionStorage.timestamp, // 必填，生成签名的时间戳
                nonceStr: sessionStorage.noncestr, // 必填，生成签名的随机串
                signature: sessionStorage.signature, // 必填，签名
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'],
            })
            let that = this

            wx.ready(function () {
                wx.onMenuShareTimeline({
                    title: that.goodsInfo ? that.goodsInfo.shareTitle : '八点秒得',
                    link: 'http://prod-app-frontend.zhijianmedia.cn/flash-sale/#/home', // 分享链接
                    imgUrl: 'http://flash-sale-end.zhijianmedia.cn/img/share-logo.8555b3c9.png',
                })

                wx.onMenuShareAppMessage({
                    title: that.goodsInfo ? that.goodsInfo.shareTitle : '八点秒得',
                    desc: '等你来参与', // 分享描述
                    link: 'http://prod-app-frontend.zhijianmedia.cn/flash-sale/#/home', // 分享链接，该链接域名必须与当前企业的可信域名一致
                    imgUrl: 'http://flash-sale-end.zhijianmedia.cn/img/share-logo.8555b3c9.png', // 分享图标
                    type: '', // 分享类型,music、video或link，不填默认为link
                    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                })
                // document.getElementById("video").play();
            })
            // }
        },
    },

    created() {
        this.getStartTime()
        this.getGoodsInfo()

        if (this.isInSmartCityApp) {
            if (process.env.NODE_ENV === 'development') {
                this.$store.commit(
                    'setUserTokenKey',
                    'JUYwJ1IGcBfpN7Bd3gwquI5dpH/8H0bNHvuxstvVKrx6s+TKaoq8ZlqKHbU0RujP1zMYbO5KV4NkYEP+fqRgACDUxQGUXefNoKAlVJmnyb4HcLMEf1oBxUe8DPolg9qy'
                )
                this.$store.commit('setNthUserInfo', {
                    userid: 1075,
                })

                this.initOrderData()
                this.finishTask()
            } else {
                this.init()
            }
        }

        if (isWechat()) {
            let openId = sessionStorage.getItem('openId')

            if (!openId) {
                // this.wxCode = "abs";
                this.getWechatCode()
                // this.getOpenId();
            } else {
                this.$store.commit('setNthUserInfo', {
                    userid: openId,
                })
                this.$store.commit('setUserTokenKey', openId)
                this.initOrderData()

                this.registerSdk()
            }
        }
    },
    mounted() {
        this.$refs.home.onscroll = debounce(() => {
            this.scrollTop = this.$refs.home.scrollTop
        }, 10)
    },
    destroyed() {
        this.stopTimer()
    },
}
</script>
<style lang="less" scoped>
.home {
    width: 100%;
    height: 100vh;
    height: calc(100vh - 80px);
    overflow-y: scroll;

    background: #fff;
    // background: #f4f4f4;

    // background: chocolate;

    .main-wrap {
        // z-index: 99;
        margin-top: -10px;
        // position: relative;
        background: #fff;
        border-radius: 10px;

        padding: 15px;
        // box-shadow: @shadow;

        .main-title {
            font-size: 16px;
            padding: 4px;

            color: #ff991d;
        }

        .main-banner {
            width: 100%;
            margin-top: 10px;
            margin-bottom: 10px;

            img {
                border-radius: 10px;
                width: 100%;
                height: 200px;
                // border-radius: 4px;
            }
        }

        .main-info {
            margin-bottom: 10px;

            .info-name {
                font-size: 16px;
                padding: 4px;
            }

            .info-price {
                span:nth-child(1) {
                    color: #ff991d;
                    font-size: 20px;
                }
                span:nth-child(2) {
                    color: #666;
                }
            }
        }

        .main-select {
            margin-bottom: 10px;
            background: #f9f9f9;
            padding: 10px;
            .select-item {
                display: flex;

                justify-content: space-between;
                align-items: center;

                .label {
                    color: #666;
                }
            }

            // .select-item:nth-child(1) {
            //   margin-bottom: 15px;
            // }
        }
        .main-btn {
            margin-bottom: 10px;
            padding: 10px;

            .van-count-down {
                color: #fff;
            }
            .btn {
                line-height: 40px;

                background: #ff991d;
                border-radius: 20px;

                text-align: center;
                color: #fff;
                display: flex;

                justify-content: center;
                align-items: center;

                span {
                    margin-right: 10px;
                }
            }

            .grey {
                background: #ccc;
            }
        }
        .main-goods {
            .goods-text {
                /deep/img {
                    // border-radius: 10px;
                    width: 100%;
                    // height: 160px;
                    // height: 214px;
                    // border-radius: 4px;
                }
                /deep/video {
                    // border-radius: 10px;
                    margin-top: 10px;

                    width: 100%;
                    // height: 160px;
                    // height: 214px;
                    // border-radius: 4px;
                }
                margin-bottom: 10px;
                /deep/p {
                    color: #666;

                    line-height: 28px;

                    // text-indent: 2em;
                }
                P {
                    margin-block-start: 0;
                    margin-block-end: 0;
                    margin-inline-start: 0px;
                    margin-inline-end: 0px;
                }
            }

            .goods-img {
                margin: 10px 0;
                img {
                    // border-radius: 10px;
                    width: 100%;
                    // height: 160px;
                    // height: 214px;
                    // border-radius: 4px;
                }
                video {
                    // border-radius: 10px;
                    margin-top: 10px;

                    width: 100%;
                    // height: 160px;
                    // height: 214px;
                    // border-radius: 4px;
                }
            }
        }
        .card-header {
            display: flex;

            justify-content: space-between;
            align-items: center;

            .ecard {
                padding: 4px 10px;
                border-radius: 10px 0 0 10px;
                background: #569aff;
                color: #fff;
                margin-right: -10px;
            }
            // flex-direction: column;
        }
    }
}

.grey {
    background: #eee;
}
.orange {
    background: #fff !important;
    color: #ff991d !important;
    border: 1px solid #ff991d;
}

.home::-webkit-scrollbar {
    display: none;
}
</style>
